import { render, staticRenderFns } from "./ListGroup.vue?vue&type=template&id=45799dca&scoped=true"
import script from "./ListGroup.vue?vue&type=script&lang=js"
export * from "./ListGroup.vue?vue&type=script&lang=js"
import style0 from "./ListGroup.vue?vue&type=style&index=0&id=45799dca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45799dca",
  null
  
)

export default component.exports